import { remove } from '@core/api/baseApi';
import { RemoveTemplateResponse } from '@core/types';

export const removeTemplate = (templateId: string): Promise<RemoveTemplateResponse> => remove(`/ReportTemplates/${templateId}`);